import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';

import './RateCorrectionValue.css';

interface RateCorrectionValueProps {
    value: number;
}

export const RateCorrectionValue = React.memo(({ value }: RateCorrectionValueProps) => {
    let signText;

    if (value > 0) {
        signText = <span className={Bem.cls('rate-correction-value', 'positive-sign')}>+</span>;
    } else if (value < 0) {
        signText = <span className={Bem.cls('rate-correction-value', 'negative-sign')}>-</span>;
    }

    return (
        <span className={classNames(Bem.cls('rate-correction-value'), TestBem.cls('rate-correction-value'))}>
            {signText}
            {Math.abs(value)}%
        </span>
    );
});
